export const environment = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  releaseName: 'release-3.5.0-414',
  buildNumber: '54cd226d19-',
};
